import type { Building } from "building-types/building/buildingTypes";
import type { BuildingStats } from "building-types/options/buildingStats";
import { assertIsNotNullOrUndefined } from "common/utils/assertOfType";
import { floorAreaTakeoffsGetConditionedArea } from "./elements/floorAreaTakeoffs/takeoffs";
import getBedBathCount from "./getBedBathCount";
import getGarageCount from "./getGarageCount";
import getStoryCount from "./getStoryCount";
import { getActiveElevation } from "./options/activeElevation";

export function buildingStatsFromBuilding(
  building: Pick<
    Building,
    "doc" | "optionChoices" | "rooms" | "walls" | "levels" | "totalFloorArea" | "floorAreaTakeoffs"
  >,
): BuildingStats {
  if (!building) {
    return {
      elevationId: "",
      elevationName: "",
      bedroomCount: 0,
      bathroomCount: 0,
      totalFloorArea: 0,
      conditionedFloorArea: 0,
      garageCount: 0,
      storyCount: 0,
    };
  }

  const { doc, optionChoices, rooms, totalFloorArea, floorAreaTakeoffs } = building;
  const activeElevation = getActiveElevation(doc, optionChoices);
  assertIsNotNullOrUndefined(activeElevation);

  const { bedroomCount, bathroomCount } = getBedBathCount(rooms);
  const conditionedFloorArea = floorAreaTakeoffsGetConditionedArea(floorAreaTakeoffs);
  const garageCount = getGarageCount(building);
  const storyCount = getStoryCount(building.levels);

  return {
    elevationId: activeElevation.option.id,
    elevationName: activeElevation.option.name,
    bedroomCount,
    bathroomCount,
    totalFloorArea,
    conditionedFloorArea,
    garageCount,
    storyCount,
  };
}
